// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__fgbZO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3ZYmx"};